module.exports = __webpack_public_path__ + "static/media/undraw_group_selfie_ijc6.f7552468.svg";